import { render, staticRenderFns } from "./DiasVencimiento.vue?vue&type=template&id=7d98164a&"
import script from "./DiasVencimiento.vue?vue&type=script&lang=js&"
export * from "./DiasVencimiento.vue?vue&type=script&lang=js&"
import style0 from "./DiasVencimiento.vue?vue&type=style&index=0&id=7d98164a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports